// TODO: Remove this file after theissue-create-stop-using-gicoptinstatusresources is cleaned
import { gicOptInStatusResources } from '@atlassian/jira-router-resources-global-issue-create-switch/src/index.tsx';
import { useResource } from '@atlassian/react-resource-router';

export const useIsModernGlobalIssueCreatePreferred = (): boolean =>
	useResource(gicOptInStatusResources).data?.gicOptInStatus?.isEnabled ?? false;
